"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isNumber;
var NUMBER_REGEX = /^[0-9]{0,8}$/;

function isNumber(value) {
  return NUMBER_REGEX.test(value) && !Array.isArray(value) && value !== '';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/TimePicker/helpers/isNumber.js
// module id = 1Tme
// module chunks = 0